import { HttpContextToken } from '@angular/common/http';

/** Set on a request to skip the loading indicator: `context: new HttpContext().set(SKIP_LOADING, true)` */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);
